// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uuPk6QWgSiIC7i3wnZZT{min-width:492px;margin-bottom:24px;padding-top:40px}.TfFuiXVw54fMjjaY2Ns8{align-items:center;gap:8px;display:flex}.VZ3gpJhYsxktlV773D0m{gap:8px;display:flex}.PvQNvCFiMgVL6wn3FVgm{text-decoration:none}.QMD7lTEClpo1VYLOM8Wq{height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"integrationSelect": `uuPk6QWgSiIC7i3wnZZT`,
	"optionWrap": `TfFuiXVw54fMjjaY2Ns8`,
	"rightLabelContainer": `VZ3gpJhYsxktlV773D0m`,
	"helpButton": `PvQNvCFiMgVL6wn3FVgm`,
	"select": `QMD7lTEClpo1VYLOM8Wq`
};
export default ___CSS_LOADER_EXPORT___;
